/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Raju Raman",
  logo_name: "R.Raman{}",
  nickname: "Raju",
  full_name: "Raju Raman",
  subTitle:
    "Full Stack Developer, Freelancer, Converting ideas into reality🔥",
  resumeLink:
    "https://drive.google.com/file/d/13WaTMh7ZdiAP5fteZENYbv1FaC4gJYbZ/view?usp=sharing",
  mail: "mailto:rajuraman45@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/rajuw892/",
  linkedin: "https://www.linkedin.com/in/rajuw892/",
  gmail: "rajuraman45@gmail.com",
  gitlab: "https://gitlab.com/rajuraman45",
  facebook: "https://www.facebook.com/rajuw892/",
  twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/rajuraman45/",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
        "⚡ Building responsive website front end using ReactJS/NextJS",
        "⚡ Developing mobile applications using React Native",
        "⚡ Creating application backend in Node & Express",
        "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },

        {
          skillName: "NextJs",
          fontAwesomeClassname: "simple-icons:next-dot-js",
          style: {
            color: "#f89820",
          },
        },
        
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        // {
        //   skillName: "GraphQL",
        //   fontAwesomeClassname: "simple-icons:graphql",
        //   style: {
        //     color: "#DE33A6",
        //   },
        // },
        
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },

    
       
     //   {
      //    skillName: "Dart",
      //    fontAwesomeClassname: "simple-icons:dart",
      //    style: {
      //      color: "#29B0EE",
      //    },
      //  },
        // {
        //   skillName: "Visual Basic",
        //   fontAwesomeClassname: "simple-icons:dot-net",
        //   style: {
        //     color: "#029FCE",
        //   },
        // },
       
       
        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },
       
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
      
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "DIT UNIVERSITY",
      subtitle: "B.Tech in Computer Science",
      logo_path: "dituniversity.jpg",
      alt_name: "dituniversity",
      duration: "2016 - 2020 ",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        "⚡ I have implemented several projects based on Web development and Machine Learning.",
      ],
      website_link: "https://www.dituniversity.edu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "M0001: MongoDB Basics",
      subtitle: "MongoDB University",
      logo_path: "mongo.png",
      certificate_link:
        "https://drive.google.com/file/d/1lGLCmzzfhqbbs90FQH1abFNs2gKrwQoQ/view?usp=sharing",
      alt_name: "MongoDB University",
      // color_code: "#2AAFED",
      color_code: "#47A048",
    },


    {
      title: "The Complete Web Development Bootcamp",
      subtitle: "HTML, CSS, Javascript, Node, React, MongoDB and more!",
      logo_path: "iit.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1haUKJO_kI8GYrxX5xxukP_SfWWMoXtzF/view?usp=sharing",
      alt_name: "Workshop",
      color_code: "#2AAFED",
    }, 

   
    {
      title: "A300: Atlas Security",
      subtitle: "MongoDB University",
      logo_path: "mongo.png",
      certificate_link:
        "https://drive.google.com/file/d/1l2hmfd8AxT3o2R7t_Eh6doc6Wjk4uZ2z/view?usp=sharing",
      alt_name: "MongoDB University",
      // color_code: "#F6B808",
      color_code: "#47A048",
    },
    {
      title: "Basic Of Web Development",
      subtitle: "Html, Css",
      logo_path: "htmlcss.jpg",
      certificate_link:
        "https://drive.google.com/file/d/17D5Orf8tNAm1F256Cdxm3Rl8yvlMwHwM/view?usp=sharing",
      alt_name: "htmlcss",
      color_code: "#E2405F",
    },
    {
      title: "Frontend Design Framework",
      subtitle: "Bootstrap",
      logo_path: "bootstrap.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1Aqte5JbnER28sm5lXezvZZe7c4RNkJFD/view?usp=sharing",
      alt_name: "bootstrap",
      color_code: "#2AAFED",
    },
    
    
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've completed one internship. I've mostly done projects on my own and I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Mern Stack Developer (Freelancer)",
          company: "Uvamy",
          company_url: "http://134.209.150.242/",
          logo_path: "uvamy.png",
          duration: "Oct 2021 - 10Dec 2021",
          location: "Work From Home",
          description:
            "Created a LMS website, where user can buy course and see the lecture",
          color: "#7A7A7A",
        },
        {
          title: "Mern Stack role (Freelancer)",
          company: "Ambhos",
          company_url: "https://ambhos.netlify.app/",
          logo_path: "ambhos.png",
          duration: "May 2021 - Sept 2021",
          location: "Work From Home",
          description:
            "Created a beautiful official site for ambhos which consist of many Health and Wellness services.",
          color: "#ee3c26",
        },
        {
          title: "Mern Stack Developer (Freelancer)",
          company: "Hussle",
          company_url: "https://hussle-dev.herokuapp.com/",
          logo_path: "husslee.jpg",
          duration: "oct 2020 - june 2021",
          location: "Work From Home",
          description:
            "Created a Website Like Linkedin for this client where user can connect with professionals, gain insight into different careers, and discover their purpose.",
          color: "#0071C5",
        },
        
      ],
    },
    {
      title: "Others",
      experiences: [
        {
          title: "Founded a Online blogging platform like verge",
          company: "Hackachu",
          company_url: "https://www.facebook.com/hackachu",
          logo_path: "hackachu.jpg",
          duration: "Dec 2016 - may2019",
          location: "Work From Home",
          description:
            "It is a platform where you'll get news about latest technology and trends",
          color: "#4285F4",
        },
         
        
         
      
         
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create projects in Nodejs And Reactjs. Below you can click on project to view the live demo of project",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "rajuraman.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others. so i'll make new blog to post it.",
    link: "www.instagram.com/rajuraman45/",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
 
    {
      id: "0",
      name: "Netflix Clone",
      url: "https://netflixclone-edd85.web.app/",
      description:
        "A React Netflix Clone which is a ui of Netflix",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "1",
      name: "Linkedin Clone",
      url: "https://linkedinclone-2b02a.web.app/",
      description:
        "A Linkedin Clone which is a ui of Linkedin here you can sign in and post your feed",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    
    {
      id: "2",
      name: "The Cocktail DB",
      url: "https://cocktaildbrr.netlify.app/",
      description:
        "It is a collection of different of Cocktail",
      languages: [
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "3",
      name: "Hussle",
      url: "https://hussle-dev.herokuapp.com/",
      description:
        "A Website Like Linkedin, Facebook, Instagram",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
      ],
    },
    {
      id: "4",
      name: "Amazon Clone",
      url: "https://amazon2-eta.vercel.app/",
      description:
        "Amzone Clone where you can add product into cart and you can checkout that product.I have also integrated stripe payment system",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    
     




  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
